import React from 'react';
import Grid from '@material-ui/core/Grid';

import Button from '@agile-actors/client/commons/components/button';

type Props = {
  classes: Object,
  content: Object,
  close: () => void,
};

const HeaderButton = ({ classes, content, close }: Props) => (
  <Grid
    container
    alignItems="center"
    onClick={close}
    className={classes.buttonWrapper}>
    <Button
      variant="contained"
      size="small"
      color="primary"
      className={classes.button}
      to={content.link}
      label={content.title}
      labelVariant="caption"
    />
  </Grid>
);

export default HeaderButton;
